// utils/farmUtils.js
import VueCookies from "vue-cookies";

export function getFarmInfo() {
  const cookieInfo = VueCookies.get("farm_info");
  if (cookieInfo && cookieInfo.farm) {
    return {
      farm: cookieInfo.farm,
      company: cookieInfo.company,
    };
  }
  return {
    farm: null,
    company: null,
  };
}
